import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
export var eventKey = 'signup-fill_email_address_on_pre_sign_up_form-click';
/**
 * Track user fill email address on pre sign up form
 */ export function trackSignupFillEmailAddressOnPreSignUpFormClick(pixelCustomDataParams) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        facebookPixelEvent: 'email-address-pre-sign-up-form',
        googleTagManagerEvent: 'email-address-pre-sign-up-form',
        pixelCustomDataParams: pixelCustomDataParams
    });
}
